/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { GroupInternalHighscore, UserGroup, UserGroupDetail } from '../../services/betting';
import {
    gihsSetAvailableGroups,
    gihsSetColumnCount,
    gihsSetColumnsEnabled,
    gihsSetGroupDetails,
    gihsSetIsLoading,
    gihsSetStartColumn,
    setGroupInternalHighscores,
    setGroupInternalUserGroupId
} from './actions';

export interface GroupInternalHighscoreState {
    userGroupId: number;
    userGroup?: UserGroupDetail;
    availableUserGroups: UserGroup[];
    highscore?: GroupInternalHighscore;
    startColumn: number;
    columnCount: number;
    leftEnabled: boolean;
    rightEnabled: boolean;
    isLoading: boolean;
}

const initialGroupInternalHighscoreState: GroupInternalHighscoreState = {
    userGroupId: 0,
    availableUserGroups: [],
    highscore: undefined,
    startColumn: 0,
    columnCount: 3,
    leftEnabled: false,
    rightEnabled: false,
    isLoading: true
};

export function groupInternalHighscoreReducer(
    state: GroupInternalHighscoreState = initialGroupInternalHighscoreState,
    action: Action
): GroupInternalHighscoreState {
    if (isType(action, setGroupInternalHighscores)) {
        return Object.assign({}, state, { highscore: action.payload });
    } else if (isType(action, setGroupInternalUserGroupId)) {
        return Object.assign({}, state, { userGroupId: action.payload });
    } else if (isType(action, gihsSetColumnCount)) {
        return { ...state, columnCount: action.payload };
    } else if (isType(action, gihsSetStartColumn)) {
        return { ...state, startColumn: action.payload };
    } else if (isType(action, gihsSetColumnsEnabled)) {
        return { ...state, leftEnabled: action.payload.leftEnabled, rightEnabled: action.payload.rightEnabled };
    } else if (isType(action, gihsSetGroupDetails)) {
        return { ...state, userGroup: action.payload };
    } else if (isType(action, gihsSetAvailableGroups)) {
        return { ...state, availableUserGroups: action.payload };
    } else if (isType(action, gihsSetIsLoading)) {
        return { ...state, isLoading: action.payload };
    }

    return state;
}
